module.exports = __webpack_public_path__ + "img/pattern2b.b0ef6fb2.png";